import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import bemBlock from '@gik/core/utils/bemBlock';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import { PageTitleFieldSet, SectionTitleAndDescription } from '@gik/inkind-page';

export interface IPageTitleSectionProps {
  id?: string;
}

export const pageTitleSectionBlockName = 'page-title-section';

const PageTitleSection: React.FC<PropsWithClassName<IPageTitleSectionProps>> = ({
  id,
  className,
}): React.ReactElement => {
  const bem = bemBlock(pageTitleSectionBlockName);
  const { t } = useTranslation();

  return (
    <SectionTitleAndDescription
      id={id}
      className={bem(null, null, className)}
      title={t(translationKeys.pageTitle)}
      description={t(translationKeys.pageTitleDescription)}
    >
      <PageTitleFieldSet className={bem('fieldset')} />
      <p className={bem('max-length')}>{t(translationKeys.pageTitleMaxLength)}</p>
    </SectionTitleAndDescription>
  );
};

export default PageTitleSection;
